import languageHelper from '@/utils/languageHelper';
import { ThemeConfig } from 'antd';
const { isFa } = languageHelper();

export const theme: ThemeConfig = {
  token: {
    colorPrimary: '#ff8601',
    colorText: '#1c2767',

    colorError: '#ea4e56',
    colorSuccess: '#64a763',
    // borderRadius: 0,
    ...(isFa ? { fontFamily: 'iranyekan' } : {}),
  },
  components: {
    Button: {
      colorPrimary: '#ff8601',
      borderRadius: 10,
      paddingContentHorizontal: 20,
      controlHeight: 46,
      ghostBg: '#FFFFFF',
      defaultGhostBorderColor: '#1c2767',
      defaultGhostColor: '#1c2767',
      colorPrimaryBg: '#ff8601',
      fontWeight: 700,
      defaultActiveBorderColor: '#1c2767',
      defaultHoverBorderColor: '#1c2767',
    },
    Select: {
      controlHeight: 46,
      borderRadius: 10,
    },
    Input: {
      paddingInline: 20,
      controlHeight: 46,
      borderRadius: 10,
    },
    InputNumber: { paddingInline: 20, controlHeight: 46, borderRadius: 10 },
    Modal: {
      padding: 0,
      paddingContentHorizontal: 0,
      paddingContentHorizontalLG: 0,
      paddingContentHorizontalSM: 0,
      paddingContentVertical: 0,
      paddingContentVerticalLG: 0,
      paddingContentVerticalSM: 0,
      paddingLG: 0,
      paddingMD: 0,
      paddingSM: 0,
      paddingXL: 0,
      paddingXS: 0,
      paddingXXS: 0,
      controlPaddingHorizontal: 0,
      controlPaddingHorizontalSM: 0,
      margin: 0,
      marginLG: 0,
      marginMD: 0,
      marginSM: 0,
      marginXL: 0,
      marginXS: 0,
      marginXXL: 0,
      marginXXS: 0,
    },
    DatePicker: {
      paddingInlineLG: 20,
      paddingInline: 20,
      paddingInlineSM: 20,
      controlHeight: 46,
      borderRadius: 10,
    },
    Form: {
      itemMarginBottom: 0,
    },
    Pagination: {
      itemActiveBg: '#1c2767',
      colorPrimary: '#FFFFFF',
      controlHeight: 46,
      fontSize: 14,
      borderRadius: 10,
      colorPrimaryHover: '#FFFFFF',
      itemActiveBgDisabled: '#000000',
    },
    Menu: {
      itemColor: '#FFF',
    },
  },
};
